import { render, staticRenderFns } from "./logCard.vue?vue&type=template&id=634ff484&lang=pug&"
import script from "./logCard.vue?vue&type=script&lang=js&"
export * from "./logCard.vue?vue&type=script&lang=js&"
import style0 from "./logCard.vue?vue&type=style&index=0&id=634ff484&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports